export const normalizeUsPhone = (raw: string): string | null => {
  let digits = raw.replace(/\D/g, '')

  while (digits.length > 10 && digits.startsWith('1')) {
    digits = digits.slice(1)
  }

  return digits.length === 10 ? `+1${digits}` : null
}

export const maskPhone = (phone: string): string => `••• ••• ${phone.replace(/\D/g, '').slice(-4)}`
